exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ghl-conversion-sync[data-v-391371c0]{background:#f3f8fb;border:1px solid #dce5eb;border-radius:10px;padding:14px;margin-bottom:20px;font-size:13px;color:#33465a}summary[data-v-391371c0]{cursor:pointer;font-weight:700}li[data-v-391371c0],p[data-v-391371c0]{margin:12px 0;line-height:1.6;overflow-wrap:anywhere}button[data-v-391371c0]{padding:6px 12px;border:1px solid #9ab9c5;border-radius:6px;margin:4px;background:#fff}", ""]);

// exports
